import * as React from "react";

function SvgTeams(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.754 7c.966 0 1.75.784 1.75 1.75v4.749a4.501 4.501 0 01-9.002 0V8.75c0-.966.783-1.75 1.75-1.75h5.502zm0 1.5H7.252a.25.25 0 00-.25.25v4.749a3.001 3.001 0 006.002 0V8.75a.25.25 0 00-.25-.25zM1.75 7h3.381a2.738 2.738 0 00-.618 1.5H1.75a.25.25 0 00-.25.25v3.249a2.5 2.5 0 003.082 2.433c.085.504.24.985.453 1.432A4 4 0 010 11.999V8.75C0 7.784.784 7 1.75 7zm13.125 0h3.375c.966 0 1.75.784 1.75 1.75V12a4 4 0 01-5.03 3.866c.214-.448.369-.929.455-1.433A2.5 2.5 0 0018.5 12V8.75a.25.25 0 00-.25-.25h-2.757a2.738 2.738 0 00-.618-1.5zM10 0a3 3 0 110 6 3 3 0 010-6zm6.5 1a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm-13 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm6.5.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.5 1a1 1 0 100 2 1 1 0 000-2zm-13 0a1 1 0 100 2 1 1 0 000-2z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgTeams;
